import { combineReducers } from "redux";

import {
  trackRedux,
  sessionRedux,
  pollRedux,
  firebaseRedux,
  generalSettingRedux,
  userRedux,
} from "./index";

export const appReducer = combineReducers({
  track: trackRedux.reducer,
  session: sessionRedux.reducer,
  poll: pollRedux.reducer,
  firebase: firebaseRedux.reducer,
  generalSettings: generalSettingRedux.reducer,
  loggedInUser: userRedux.reducer,
});

export const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === "USER_LOGGED_OUT") {
    const { generalSettings } = state;
    state = { generalSettings };
  }

  return appReducer(state, action);
};

// export default rootReducer;
